import { configureStore } from "@reduxjs/toolkit";
import { alertSlice } from "./featuers/alertSlice";
import { optionSlice } from './featuers/optionSlice';

export const store = configureStore({
  reducer: {
    alert: alertSlice.reducer,
    option: optionSlice.reducer, 
  },
});

console.log(store.getState());
